export default __webpack_public_path__ + "static/media/bg-contact.16bcd09d.png";